import { render, staticRenderFns } from "./MypageMyinfoPage.vue?vue&type=template&id=2f2b91f4&"
import script from "./MypageMyinfoPage.vue?vue&type=script&lang=js&"
export * from "./MypageMyinfoPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports